import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Title, Link } from '@express-labs/raven-ui';
import s from './EccBenefitsModal.module.scss';

function EccBenefitsModal({ openModal, closeModal, returnText, eccText }) {
  if (!(returnText || eccText)) {
    return null;
  }

  return (
    <Modal isOpen={openModal} className={s.eccBenefitsModal} onModalClose={closeModal} appElement={document.getElementById('root')}>
      <div className={s.content} data-testid="content">
        {returnText && (
          <>
            {returnText?.copy_title && <Title tag="h3">{returnText.copy_title}</Title>}
            {returnText?.description && <p className='bodySecondary'>{returnText.description}</p>}
            {returnText?.link?.href && returnText?.link?.title && (
              <Link
                as="a"
                size="body"
                theme="dark"
                href={returnText.link.href}
                className={s.link}
              >
                {returnText.link.title}
              </Link>
            )}
          </>
        )}
        {eccText && (
          <>
            {eccText?.copy_title && <Title tag="h3">{eccText.copy_title}</Title>}
            {eccText?.description && <p className='bodySecondary'>{eccText.description}</p>}
            {eccText?.link?.href && eccText?.link?.title && (
              <Link
                as="a"
                size="body"
                theme="dark"
                href={eccText.link.href}
                className={s.link}
              >
                {eccText.link.title}
              </Link>
            )}
          </>
        )}
      </div>
    </Modal>
  );
}

EccBenefitsModal.propTypes = {
  openModal: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  returnText: PropTypes.shape({
    title: PropTypes.string,
    copy_title: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.shape({
      href: PropTypes.string,
      title: PropTypes.string,
    })
  }),
  eccText: PropTypes.shape({
    title: PropTypes.string,
    copy_title: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.shape({
      href: PropTypes.string,
      title: PropTypes.string,
    })
  }),
};

EccBenefitsModal.defaultProps = {
  openModal: false,
  returnText: null,
  eccText: null,
};

export default EccBenefitsModal;
